import { Box, Button } from '@mui/material';
import type React from 'react';

interface WizardNavigationProps {
  activeStep: number;
  onBack: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  onBackToAccount?: () => void;
}

const WizardNavigation: React.FC<WizardNavigationProps> = ({
  activeStep,
  onBack,
  onNext,
  isNextDisabled = false,
  onBackToAccount,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
      {activeStep === 0 && onBackToAccount ? (
        <Button onClick={onBackToAccount} variant="outlined">
          Back to Account
        </Button>
      ) : activeStep > 0 ? (
        <Button onClick={onBack} variant="outlined">
          Back
        </Button>
      ) : null}
      {activeStep < 6 && (
        <Button
          onClick={onNext}
          variant="contained"
          disabled={isNextDisabled}
          sx={{ ml: activeStep === 0 && !onBackToAccount ? 'auto' : 0 }}
        >
          Next
        </Button>
      )}
    </Box>
  );
};

export default WizardNavigation;
